import { Td } from './styles'
import { Tr } from '@chakra-ui/table'
import React from 'react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Text } from '@chakra-ui/react'

export function Row({ item }) {
  const formattedDateInitial = item.data_inicio_troca
    ? format(new Date(item.data_inicio_troca), 'dd/MM/yyyy HH:mm', {
        locale: ptBR,
      })
    : 'Sem data'

  const formattedDateFinal = item.data_termino_troca
    ? format(new Date(item.data_termino_troca), 'dd/MM/yyyy HH:mm', {
        locale: ptBR,
      })
    : 'Sem data'

  const formattedDateEntrega = item.data_entrega
    ? format(new Date(item.data_entrega), 'dd/MM/yyyy HH:mm', {
        locale: ptBR,
      })
    : 'Sem data'

  const percentTroca = `${parseFloat(item.percentual_troca).toFixed(2)}%`

  return (
    <Tr>
      <Td>
        <Text as="a" href={item.link_layout} target="_blank" rel="noreferrer" color={'blue.500'} textDecoration="underline">
          {item.pedido}
        </Text>
      </Td>
      <Td>{item.cod_innovation}</Td>
      <Td>{item.fornecedor}</Td>
      <Td>{item.quantidade} un.</Td>
      <Td>{item.quantidade_troca} un.</Td>
      <Td>{item.numero_trocas_total}</Td>
      <Td>{percentTroca}</Td>
      <Td>{formattedDateInitial}</Td>
      <Td>{formattedDateFinal}</Td>
      <Td>{formattedDateEntrega}</Td>
      <Td>{item.dias_producao}</Td>
    </Tr>
  )
}
